import React, {useEffect} from 'react';
import {connect} from "react-redux";
import MainContainer from "../MainContainer";
import {withRouter} from "react-router";
import {getSharedResume} from "../../../redux/profile/profile-thunks";
import {setSharedResume} from "../../../redux/profile/profile-actions";

const Shared = ({location, ...props}) => {
  useEffect(() => {
    if(location.search.length > 0 && location.search.split('=')[0] === '?resume_id') {
      props.getSharedResume(location.search.split('=')[1])
    }
    return () => {
      props.setSharedResume(null)
    }
  }, [])
  return (
    <MainContainer>
      {props.sharedResume && <div className={'wrapper mt-24'}
                                  dangerouslySetInnerHTML={{__html: props.sharedResume}} />}
    </MainContainer>
  );
};

const mapStateToProps = (state) => ({
  sharedResume: state.profileReducer.sharedResume
})

export default connect(mapStateToProps, {getSharedResume, setSharedResume})(withRouter(Shared));
